// extracted by mini-css-extract-plugin
module.exports = {"Container":"Spinner_Container__6WMzI","AnimatedBackground":"Spinner_AnimatedBackground__OP8rz"};